import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Menu, Typography } from "@material-ui/core";
import ColumnNameGroup from "components/WPReactTable/components/ColumnNameGroup";
import { AddHeading } from "components/WPReactTable/components/HeadingColumn";
import NameInput from "components/WPReactTable/components/NameInput";
import { apiService } from "constants/axiosInstance";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import { get } from "lodash";
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import i18n from "i18next";
import {
  StyledMenuItem,
  StyledListItemIcon,
} from "components/WPReactTable/components/HeaderColumn";
import {
  deleteTask,
  chooseTask,
  showModalJobDetail,
} from "actions/taskDetail/taskDetailActions";
import { viewChat } from "actions/chat/chat";
import AlertModal from "components/AlertModal";
import { listTask } from "actions/task/listTask";

export const IconDrag = () => (
  <svg
    viewBox="0 0 24 24"
    role="presentation"
    style={{
      width: "1.5rem",
      height: "1.5rem",
    }}
  >
    <path
      d="M9,3H11V5H9V3M13,3H15V5H13V3M9,7H11V9H9V7M13,7H15V9H13V7M9,11H11V13H9V11M13,11H15V13H13V11M9,15H11V17H9V15M13,15H15V17H13V15M9,19H11V21H9V19M13,19H15V21H13V19Z"
      style={{ fill: "currentcolor" }}
    />
  </svg>
);

const CellItemGroup = ({
  value,
  row,
  projectId,
  isNewRow = false,
  dragHandle = {},
  onSubmitAdd = () => {},
  onBlur = () => {},
  editNameFinish = () => {},
  isFocus = true,
  canEdit,
}) => {
  const { t } = useTranslation();
  const refNameInput = useRef(null);
  const [name, setName] = React.useState(isNewRow ? "" : value);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [isEditing, setIsEditing] = React.useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    isNewRow ? setName("") : setName(value);
  }, [value, isNewRow]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (isEditing || isNewRow) {
        refNameInput.current && refNameInput.current.focus();
        refNameInput.current && refNameInput.current.moveToEnd();
      }
    }, 0);
    return () => clearTimeout(timeout);
  }, [isNewRow, isEditing]);

  const _handleSubmit = async (val, enterAction) => {
    if (isNewRow) return onSubmitAdd(name, enterAction);

    try {
      const config = {
        url: "/task/update-name-description",
        method: "PUT",
        data: {
          task_id: row?.original?.id || null,
          name: val,
        },
      };
      const result = await apiService(config);
      if (result?.data?.state) {
        SnackbarEmitter(SNACKBAR_VARIANT.SUCCESS, t("SNACK_MUTATE_SUCCESS"));

        setName(val);
        setTimeout(() => {
          editNameFinish(row.id);
        }, 1000);
      }
    } catch (error) {
      refNameInput.current = name;
      // dispatch(listTask({ projectId }, true));
      refNameInput.current.onChange(value);
      SnackbarEmitter(
        SNACKBAR_VARIANT.ERROR,
        get(error, "message", DEFAULT_MESSAGE.QUERY.ERROR)
      );
    }
  };

  const handleRemoveFocus = (e) => {
    if (!e) return;
    const columnHTML = e.target.closest(".td");
    columnHTML.classList.remove("focus");
  };

  const _handleKeyPress = (e) => {
    if (e.which === 13 && !e.shiftKey) {
      isEditing && handleRemoveFocus(e);
      setIsEditing(false);
      e.preventDefault();
      if (e.target.value && e.target.value?.trim() !== name?.trim()) {
        _handleSubmit(e.target.value, true);
        onBlur(e);
      } else {
        editNameFinish(row.id);
      }
    }
  };

  const _handleBlur = (e) => {
    setIsEditing(false);
    const columnHTML = e.target.closest(".td");
    columnHTML.classList.remove("focus");
    onBlur(e);
    if (e.target.value?.trim() !== name?.trim())
      _handleSubmit(e.target.value, false);
  };

  const _handleFocus = (e) => {
    const columnHTML = e.target.closest(".td");
    columnHTML.classList.add("focus");
    refNameInput.current.moveToEnd();
  };

  const handleFocusFromMenu = () => {
    _handleCloseMenu();
    setIsEditing(true);

    if (refNameInput.current) {
      setTimeout(() => {
        refNameInput.current.focus();
        refNameInput.current.moveToEnd();
      }, 0);
    }
  };

  const _handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const _handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDeleteTask = () => {
    dispatch(
      deleteTask({
        taskId: row?.original?.id,
      })
    );
  };

  const handleDeleteConfirm = () => {
    setOpenConfirm(true);
    setAnchorEl(null);
  };
  const closeDeleteConfirm = (value) => {
    setOpenConfirm(false);
  };
  const _handleEditing = () => {
    if (!canEdit) return;
    setIsEditing(true);
  };

  const handleShowModalJobDetail = (e, taskId) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(showModalJobDetail(true));
    dispatch(chooseTask(taskId));
    dispatch(viewChat(taskId));
  };

  const renderMenu = () => {
    return (
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={_handleCloseMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "start" }}
        transformOrigin={{ vertical: "top", horizontal: "start" }}
      >
        <StyledMenuItem
          style={{ marginBottom: 5 }}
          onClick={handleFocusFromMenu}
        >
          <StyledListItemIcon>
            <ModeEditOutlinedIcon />
          </StyledListItemIcon>
          <Typography textAlign="center">Chỉnh sửa</Typography>
        </StyledMenuItem>

        <StyledMenuItem style={{ marginTop: 5 }} onClick={handleDeleteConfirm}>
          <StyledListItemIcon>
            <DeleteOutlineIcon />
          </StyledListItemIcon>
          <Typography textAlign="center">Xóa công việc</Typography>
        </StyledMenuItem>
      </Menu>
    );
  };

  const renderInput = () => {
    if (isEditing || isNewRow)
      return (
        <NameInput
          ref={refNameInput}
          defaultValue={isNewRow ? "" : name}
          onFocus={_handleFocus}
          onKeyPress={_handleKeyPress}
          maxWidth="100%"
          width="100%"
          // onChange={_handleChange}
          onBlur={_handleBlur}
          canEdit={canEdit}
        />
      );
    return (
      <WrapperName onClick={_handleEditing}>
        <StyledHeadingGroup>{name}</StyledHeadingGroup>
      </WrapperName>
    );
  };
  const isTemplate = document.location.pathname.search("/projects/template");
  return (
    <>
      <WrapperItemName>
        <div style={{ width: "30px" }} />
        {canEdit && (
          <WrapperIconDrag className="drag-icon" {...dragHandle}>
            <IconDrag />
          </WrapperIconDrag>
        )}
        {renderInput()}
        <WrapperDetailInfo className="detail-info">
          {canEdit && (
            <div className="wp-wrapper-button">
              <MoreVertIcon sx={{ fontSize: 16 }} onClick={_handleOpenMenu} />
            </div>
          )}
          {isTemplate === -1 && (
            <span
              onClick={(e) => {
                // console.log(row);
                // return;
                handleShowModalJobDetail(e, row?.original?.id);
              }}
              className="detail"
              style={{ color: "#000" }}
            >
              {/* abc */}
              <span>{t("LABEL_CELL_TEXT_DETAIL")}</span>{" "}
              <ChevronRightIcon sx={{ fontSize: 16 }} />
            </span>
          )}
        </WrapperDetailInfo>
        {canEdit && renderMenu()}
      </WrapperItemName>
      <AlertModal
        open={openConfirm}
        setOpen={closeDeleteConfirm}
        content={"Bạn có chắc muốn xóa?"}
        onConfirm={() => {
          handleDeleteTask();
        }}
      />
    </>
  );
};

const CellNameTask = ({ row, value, ...props }) => {
  if (row.depth === 0 && !props.isNewRow) {
    return (
      <ColumnNameGroup
        row={row}
        value={value}
        dragHandle={props.dragHandle}
        onMouseDown={props.onMouseDown}
        onToggleAdd={props.handleToggleAdd}
        canEdit={props?.canEdit}
        {...props}
      />
    );
  }

  return (
    <CellItemGroup
      row={row}
      value={value}
      isNewRow={props.isNewRow}
      dragHandle={props.dragHandle}
      canEdit={props?.canEdit}
      {...props}
    />
  );
};

export const COLUMNS_TASK_TABLE = [
  {
    id: "pfd-name",
    Header: i18n.t("Tên công việc"),
    headerClassName: "sticky",
    minWidth: 420,
    maxWidth: 620,
    sticky: "left",
    accessor: "name",
    Cell: CellNameTask,
  },
  {
    id: "add-column",
    Header: (props) => <AddHeading props={props} />,
    width: 50,
  },
];

const WrapperIconDrag = styled.div`
  position: absolute;
  top: 50%;
  height: 19.5px;
  transform: translateY(-50%);
  visibility: hidden;
  position: absolute;
  left: 8px;
`;
const WrapperDetailInfo = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  z-index: 2;
  cursor: pointer;
  height: 100%;
  padding: 0 15px;
  visibility: hidden;
  .detail {
    padding: 5px 8px;
    border-radius: 5px;
    span {
      font-size: 11px;
      font-weight: 400;
    }
    display: flex;
    align-items: center;
    &:hover {
      background: #f0eeef;
    }
  }
  &:hover {
    background-color: #f9f8f8;
  }
`;
const WrapperItemName = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  &:hover {
    ${WrapperIconDrag} {
      visibility: visible;
    }
  }
`;

const TextEllipsis = styled.span`
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #1e1f21;
  max-width: 100%;
  display: block;
`;

const WrapperName = styled.div`
  // min-height: 36px;
  font-size: 14px;
  // font-weight: 400;
  margin-left: 0;
  min-width: 120px;
  outline: none;
  cursor: pointer;
  // background: yellow;
  max-width: calc(100% - 160px);
  min-width: 150px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledHeadingGroup = styled(TextEllipsis)`
  font-size: 14px;
  line-height: 20px;
  margin-left: 0;
  min-width: 1px;
  outline: none;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
